__turbopack_context__.v({
  "avatar": "collab-card-module__2touxG__avatar",
  "bio": "collab-card-module__2touxG__bio",
  "btns": "collab-card-module__2touxG__btns",
  "card": "collab-card-module__2touxG__card",
  "collab": "collab-card-module__2touxG__collab",
  "inline": "collab-card-module__2touxG__inline",
  "link": "collab-card-module__2touxG__link",
  "nom": "collab-card-module__2touxG__nom",
  "phone": "collab-card-module__2touxG__phone",
  "wrapper": "collab-card-module__2touxG__wrapper",
});
